import { useState, useEffect } from "react";
import Modulo from "../../components/modulo";
// import { MODULOS_REPORTES } from "./modulos-configuracion-general";
import "../../style/style-cargando.css";
import SinAccesoCard from "../../components/sin-acceso-card";
import cargandoCard from "../../components/cargando-card";
import { useModulosReportes } from "./modulos-configuracion-general";

export default function ReportesScreen() {

    const [cargandoPage, setCargandoPage] = useState(false);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
    const MODULOS_REPORTES = useModulosReportes();

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return SinAccesoCard();
            }
            return (
                <div>
                    <div className="flex flex-wrap">
                        {MODULOS_REPORTES.map((data) => Modulo(data))}
                    </div>
                </div>
            );
        } catch (err) {
            console.log("ConfiguracionMain render");
            console.log(err);
            return (
                <div className=" w-1/2 m-auto px-[2rem] ">
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
}
